import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsVisible(scrollPosition > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          isVisible
            ? 'translate-y-0 opacity-100'
            : '-translate-y-full opacity-0'
        }`}
      >
        <div className="bg-white/90 backdrop-blur-md border-b-2 border-[#1A532F]">
          <div className="max-w-7xl mx-auto px-6 py-4">
            <div className="flex items-center justify-between">
              <button
                onClick={() => scrollToSection('hero')}
                className="text-2xl font-bold text-[#1A532F] hover:text-[#E64A2B] transition-colors pixel-text"
              >
                unmapped.blr
              </button>

              {/* Desktop Menu */}
              <div className="hidden md:flex items-center space-x-8">
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-[#1A532F] hover:text-[#E64A2B] transition-colors font-medium"
                >
                  Who are we?
                </button>
                <button
                  onClick={() => scrollToSection('upcoming-projects')}
                  className="text-[#1A532F] hover:text-[#E64A2B] transition-colors font-medium"
                >
                  Upcoming
                </button>
                <button
                  onClick={() => scrollToSection('walks')}
                  className="text-[#1A532F] hover:text-[#E64A2B] transition-colors font-medium"
                >
                  Walks
                </button>
                <button
                  onClick={() => scrollToSection('games')}
                  className="text-[#1A532F] hover:text-[#E64A2B] transition-colors font-medium"
                >
                  Games
                </button>
                <button
                  onClick={() => scrollToSection('workshops')}
                  className="text-[#1A532F] hover:text-[#E64A2B] transition-colors font-medium"
                >
                  Workshops
                </button>
              </div>

              {/* Mobile Menu Button */}
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="md:hidden text-[#1A532F] hover:text-[#E64A2B] transition-colors"
              >
                {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white/95 backdrop-blur-md border-b-2 border-[#1A532F]">
            <div className="px-6 py-4 space-y-4">
              <button
                onClick={() => scrollToSection('about')}
                className="block w-full text-left text-[#1A532F] hover:text-[#E64A2B] transition-colors font-medium py-2"
              >
                Who are we?
              </button>
              <button
                onClick={() => scrollToSection('upcoming-projects')}
                className="block w-full text-left text-[#1A532F] hover:text-[#E64A2B] transition-colors font-medium py-2"
              >
                Upcoming
              </button>
              <button
                onClick={() => scrollToSection('walks')}
                className="block w-full text-left text-[#1A532F] hover:text-[#E64A2B] transition-colors font-medium py-2"
              >
                Walks
              </button>
              <button
                onClick={() => scrollToSection('games')}
                className="block w-full text-left text-[#1A532F] hover:text-[#E64A2B] transition-colors font-medium py-2"
              >
                Games
              </button>
              <button
                onClick={() => scrollToSection('workshops')}
                className="block w-full text-left text-[#1A532F] hover:text-[#E64A2B] transition-colors font-medium py-2"
              >
                Workshops
              </button>
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default Navigation;
